const Genesis = require("../Genesis.js")
import { Toast } from "bootstrap";
import { post } from "jquery";
import { Modal } from "bootstrap";
import { LibraryTreeManager } from "../Document/LibraryTreeManager";
import { BlockPageHelper } from "../Helpers/helpers";
import Swal from "sweetalert2";
import { MapComponent } from '../Shared/GoogleMap/MapComponent';
import { ButtonBadge } from "../Components/ButtonBadge";

interface CheckpointActionTracker {
    IsCompleted: boolean;
    OccurrenceId: number;
    CheckpointActionId: number;
    AdditionalActionId: number;
}
export class ISiteMobileWorkOrderPPMJobScreenPage {
    private actionListModal: Modal | null = null;
    private isActionsPopulated = false;
    private pdfContent: any;
    private libraryTreeManager: LibraryTreeManager = new LibraryTreeManager("#upload-document-library-tree", 1078, true);
    private mapComponent: MapComponent = new MapComponent()

    public Init() {
        $(document).ready(() => {
            const placeholder = $("#main-content");
            const id = $("#recordId").val();
            $.ajax({
                cache: false,
                url: Genesis.url(`/WorkOrder/_PPMJobScreenContent/${id}`)
            }).done((html) => {
                placeholder.html(html);

                $("#remedialCreate").click(function () {
                    const occId = $("#hdnOccurrenceId").val();

                    $.ajax({
                        url: Genesis.url("/WorkOrder/GetNextOccurrenceRemedial"),
                        type: "POST",
                        dataType: "json",
                        data: { occurrenceId: occId },
                        success: function (data) {
                            var propertyId = $("#hdnPropertyId").val();
                            var remidialWorkOrderRef = data;
                            window.location.href = Genesis.url('/WorkOrder/Edit?OccurrenceID=' + occId + '&IsRemedial=true&RecordRef=' + remidialWorkOrderRef + "&PropertyId=" + propertyId);
                        }
                    })
                });

                $("#generateDocket").click(() => {
                    this.generateDocket(() => {
                        kendo.saveAs({
                            dataURI: this.pdfContent,
                            fileName: "PdfReport.pdf"
                        });
                    });
                });

                if ($("#signOffWork").length) {
                    $("#signOffWork").click((e: any) => {
                        const form: HTMLFormElement | null = document.querySelector("#signoffForm")
                        if (form !== null) {
                            if (!form.checkValidity()) {
                                form.classList.add('was-validated');
                                Swal.fire("Sign off", "Please enter the three Sign off fields.")
                                return false;
                            }
                        }
                        this.showUploadForm();
                    });
                };

                $("#uploadPdf").click(() => {
                    this.generateDocket(() => {
                        const libraries = this.libraryTreeManager.GetSelectedLibraries();
                        if (libraries.length == 0) {
                            Swal.fire("Library Selection", "Please select at least one library.")
                            return;
                        }
                        $("#WorkOrder_UploadReportModal").hide();
                        BlockPageHelper.block();

                        const occId = $("#hdnOccurrenceId").val();

                        const data = {
                            id: occId,
                            completeDate: $("#Signoff_CompleteDate").val() as string,
                            completeComment: $("#Signoff_CompleteComment").val() as string,
                            libraryIds: libraries,
                            file: this.pdfContent
                        }
                        $.post({
                            url: Genesis.url(`/WorkOrder/UploadPdfReport`),
                            data: data
                        }).done(function () {
                            Swal.fire("Upload Success", "Success");
                            location.reload();
                        }).fail(function () {
                            Swal.fire("Upload Failure", "Failed");
                        }).always(function () {
                            BlockPageHelper.unblock();
                        });
                    });
                });

                if ($("#btnCompleteWork").length) {
                    $("#btnCompleteWork").click(() => {
                        Swal.fire({
                            title: 'Are you sure you want to Complete the Work Order?',
                            showDenyButton: false,
                            showCancelButton: true,
                            confirmButtonText: 'Complete Work'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                BlockPageHelper.block();
                                $.post('/WorkOrder/CompleteOccurrence', { id: $("#hdnOccurrenceId").val() })
                                    .done(function (data) {
                                        $("#btnCompleteWork").hide();
                                        Swal.fire("Success", "The Work Order was Completed successfully.")

                                        location.reload();
                                    }).fail(() => {
                                        Swal.fire("Failed", "There was an error Completing Work Order. Please try again.")
                                    }).
                                    always(() => {
                                        BlockPageHelper.unblock();
                                    });
                            }
                        })

                    });
                };

                $("#btnRenderAction").click(() => this.ShowActionListData());
                $("#btnSaveAction").click(() => this.SaveActionTracker());
                $("#propertylink").click(function () {
                    $('#propertylinklist').slideToggle('slow');
                });

                this.mapComponent.initMap();
                const badges = new ButtonBadge();
                badges.Init();
                this.ManageActions();
            });

        });

    }

    public ShowActionListData() {
        const modalEl = document.getElementById('actionListModal');
        if (modalEl !== null && this.isActionsPopulated) {
            this.actionListModal = new Modal(modalEl);
            this.actionListModal.show();
        }
        if (modalEl !== null && !this.isActionsPopulated) {
            $.ajax({
                url: Genesis.url("/WorkOrder/CheckPointActionView"),
                type: "POST",
                dataType: "html",
                data: { occuranceId: $("#hdnOccurrenceId").val() },
                success: (response) => {
                    $("#actionListPlaceHolder").html(response);
                    this.isActionsPopulated = true;
                    this.actionListModal = new Modal(modalEl);
                    this.actionListModal.show();

                    $(".form-Checkpoint").hide();
                    $("#btnCancelAction").click(() => this.HideActionForm());
                    $("#btnToggleAction").click(() => this.ShowActionForm());
                    $("#btnSaveAdditionalAction").click(() => this.AddCheckpointAction());
                }
            });
        }
    }

    private showUploadForm() {
        BlockPageHelper.block();
        this.saveReport().done((data) => {
            this.pdfContent = data;
            $.get(Genesis.url("/Document/_PdfReportUploadModal")).done((data) => {
                $("#reportUploadModalBodyContent").html(data);
                setTimeout(() => {
                    this.libraryTreeManager = new LibraryTreeManager("#upload-document-library-tree", 1078, true);
                    this.libraryTreeManager.init();
                    const modalEl = document.getElementById('WorkOrder_UploadReportModal');
                    if (modalEl !== null) {
                        const modal = new Modal(modalEl);
                        modal.show();
                    }
                    BlockPageHelper.unblock();
                }, 1000);

            });
        });
    }

    private saveReport() {
        $("#plannedMaintenaceWOReportPlaceholder").show();
        $("label[for=Docket_CompleteDate]").parent().next().text($("#Signoff_CompleteDate").val() as string);
        $("label[for=Docket_Signature]").parent().next().text($("#Signoff_Signature").val() as string);
        $("label[for=Docket_EngineerName]").parent().next().text($("label[for=Signoff_EngineerName]").parent().next().text() as string);
        $("label[for=Docket_CompleteComment]").parent().next().text($("#Signoff_CompleteComment").val() as string);
        return kendo.drawing.drawDOM($("#plannedMaintenaceWOReportPlaceholder"), {
            paperSize: "A4",
            multiPage: true,
            margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
            keepTogether: ".prevent-split",
            forcePageBreak: ".pdf-page-break"
        }).then(function (group) {
            // Render the result as a PDF file
            $("#plannedMaintenaceWOReportPlaceholder").hide();
            return kendo.drawing.exportPDF(group, { margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }, paperSize: "A4" });
        });
    };

    private generateDocket(onSuccess: () => void) {
        BlockPageHelper.block();
        const occId = $("#hdnOccurrenceId").val();
        $.get({
            url: Genesis.url("/WorkOrder/_PdfReportContent"),
            type: 'GET',
            data: { id: occId },
            success: (response: any) => {
                $("#plannedMaintenaceWOReportPlaceholder").html(response);
                this.saveReport().done((pdf: any) => {
                    // Save the PDF file
                    this.pdfContent = pdf;
                    onSuccess();
                    BlockPageHelper.unblock();
                });
            },
            error: () => {
                BlockPageHelper.unblock();
            }
        });
    }

    public SaveActionTracker() {
        BlockPageHelper.block();
        this.actionListModal?.hide();
        var _that = this;
        let checkpointActionTracker: CheckpointActionTracker[] = [];
        $('.Action-Completed').each(function () {
            var IsCompleted = $(this).prop('checked');
            var OccurrenceId = $(this).data('occurrenceid');
            var CheckpointActionId = $(this).data('checkpointactionid');
            var AdditionalActionId = $(this).data('additionalactionid');
            checkpointActionTracker.push({
                IsCompleted: IsCompleted,
                OccurrenceId: OccurrenceId,
                CheckpointActionId: CheckpointActionId,
                AdditionalActionId: AdditionalActionId
            });
        });

        $.post(Genesis.url("/WorkOrder/SaveCheckpointAction"), {
            checkpointActionTrackerList: checkpointActionTracker
        }, function (responseData) {
            Swal.fire("Success", "Checkpoint Action were saved Successfully.")
        }).fail(() => {
            Swal.fire("Failed", "There was an error, while saving the Checkpoint Action. Please try again.")
        }).always(function () {
            BlockPageHelper.unblock();
        });
    }

    public ShowActionForm() {
        $(".form-Checkpoint").show();
    }

    public HideActionForm() {
        $(".form-Checkpoint").hide();
    }

    public AddCheckpointAction() {
        if ($("#txtCheckpoint").val() == "") {
            Swal.fire("Failed", "Checkpoint Action Required.")
            return;
        }

        var _that = this;
        $.post(Genesis.url("/WorkOrder/SaveOccurrenceAdditionalAction"), {
            AdditionalAction: $("#txtCheckpoint").val(),
            OccurrenceId: $("#hdnOccurrenceId").val()
        }, function (responseData) {
            Swal.fire("Success", "Checkpoint Action were Added Successfully.")
            _that.PopulateActionListData();
        }).fail(() => {
            Swal.fire("Failed", "There was an error, while saving the Checkpoint Action. Please try again.")
        }).always(function () {
            BlockPageHelper.unblock();
        });
    }

    public PopulateActionListData() {
        $.ajax({
            url: Genesis.url("/WorkOrder/CheckPointActionView"),
            type: "POST",
            dataType: "html",
            data: { occuranceId: $("#hdnOccurrenceId").val() },
            success: (response) => {
                $("#actionListPlaceHolder").html(response);

                $(".form-Checkpoint").hide();
                $("#btnCancelAction").click(() => this.HideActionForm());
                $("#btnToggleAction").click(() => this.ShowActionForm());
                $("#btnSaveAdditionalAction").click(() => this.AddCheckpointAction());
            }
        });
    }

    public ManageActions() {
        var _that = this;

        //Edit Action Layout 
        $(document).on("click", ".edit-action", function (this: HTMLElement) {
            var row = $(this).closest("tr");

            var additionalAction = row.data("action");
            row.find(".action-text").html();

            row.find(".action-text").html(
                `<input class="hdnAdditionalAction" type="hidden" value="${additionalAction}" />` +
                `<input type="text" class="form-control edit-action-text" value="${additionalAction}" />`
            );

            row.find(".Action-Completed").prop("disabled", true);

            row.find(".action-buttons").html(
                '<i class="fa fa-check update-Action" aria-hidden="true"></i> &nbsp;' +
                '<i class="fa fa-ban cancel-edit" aria-hidden="true"></i>'
            );
        });

        //Cancel Edit Action Layout - Exit from Edit
        $(document).on("click", ".cancel-edit", function (this: HTMLElement) {
            var row = $(this).closest("tr");

            var additionalAction = row.find(".hdnAdditionalAction").val();
            row.find(".action-text").html();

            row.find(".action-text").html(
                `<span class="action-text">${additionalAction}</span>`
            );

            row.find(".Action-Completed").prop("disabled", false);

            row.find(".action-buttons").html(
                '<i class="fa fa-edit edit-action" aria-hidden="true"></i>&nbsp;' +
                '<i class="fa fa-trash delete-action" aria-hidden="true"></i>'
            );
        });

        //Delete Action Layout
        $(document).on("click", ".delete-action", function (this: HTMLElement) {
            var row = $(this).closest("tr");
            var additionalAction = row.data("action");

            Swal.fire({
                title: `Are you sure you want to Delete this Action - ${additionalAction}?`,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Yes'
            }).then((result) => {
                var row = $(this).closest("tr");
                if (result.isConfirmed) {
                    BlockPageHelper.block();

                    $.post(Genesis.url("/WorkOrder/DeleteAdditionalAction"),
                        {
                            additionalActionId: row.data("additionalactionid"),
                            OccurrenceId: $("#hdnOccurrenceId").val()
                        }).done(function (data) {
                            Swal.fire("Success", "Checkpoint Action were Deleted Successfully.");
                            _that.PopulateActionListData();
                        }).fail(() => {
                            Swal.fire("Failed", "There was an error, while Deleting the Checkpoint Action. Please try again.");
                        }).always(function () {
                            BlockPageHelper.unblock();
                        });
                }
            });
        });

        //Update/Rename Additional Action
        $(document).on("click", ".update-Action", function (this: HTMLElement) {

            BlockPageHelper.block();

            var row = $(this).closest("tr");
            var additionalAction = row.find(".edit-action-text").val();

            $.post(Genesis.url("/WorkOrder/SaveOccurrenceAdditionalAction"),
                {
                    AdditionalAction: additionalAction,
                    AdditionalActionId: row.data("additionalactionid"),
                    OccurrenceId: $("#hdnOccurrenceId").val()
                }).done(function (data) {
                    Swal.fire("Success", "Checkpoint Action were Updated Successfully.")
                    _that.PopulateActionListData();
                }).fail(() => {
                    Swal.fire("Failed", "There was an error, while saving the Checkpoint Action. Please try again.")
                }).always(function () {
                    BlockPageHelper.unblock();
                });
        });
    }
};